import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { ApiConfig } from '@/config/api.config';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import { UrlHelper } from '@/utils/UrlHelper';
import { UserActivityChartResponseDto } from '@/features/superAdmin/features/dashboard/types/super-admin-dashboard-dto';
import { useSuperAdminDashboardFilter } from '@/features/superAdmin/features/dashboard/store/useSuperAdminDashboardFilter';
import { DateTimeHelper } from '@/utils/dateTimeHelper';

export const useUserActivityChartApi = () => {
    const axiosInstance = useAxiosAuth();

    const { filter } = useSuperAdminDashboardFilter();
    const { startDate, endDate, reportPeriod, activityType, searchText } = filter;

    const {
        data: userActivityChartData,
        isLoading: isLoadingUserActivityChartData,
        isError: isErrorUserActivityChartData,
    } = useQuery({
        queryKey: [
            ApiConfig.queries.superAdmin.dashboard.queryKeys.userActivityChart,
            startDate,
            endDate,
            activityType,
            reportPeriod,
            searchText,
        ],
        queryFn: async (): Promise<UserActivityChartResponseDto> => {
            const url = UrlHelper.buildUrlWithQueryParams(
                ApiConfig.queries.superAdmin.dashboard.endpoints.userActivityChart,
                {
                    startDate: DateTimeHelper.getDateOnly(startDate),
                    endDate: DateTimeHelper.getDateOnly(endDate),
                    activityType,
                    reportPeriod,
                    searchText,
                },
            );
            const response = await axiosInstance.get<UserActivityChartResponseDto>(url);
            return response.data;
        },
        placeholderData: keepPreviousData,
    });

    return {
        userActivityChartData,
        isLoadingUserActivityChartData,
        isErrorUserActivityChartData,
    };
};
